import { Buffer } from 'buffer';
import { api } from '@/services/api';
import { setItem } from '@/helpers/common/localStorage';
import { REACT_APP_AUTH, REACT_APP_USER } from '@/utils/config';
import { Auth } from '@/model/Auth';

export const loginClient = async (cpf: string, password: string): Promise<Auth> => {
  const payload = Buffer.from(`${cpf}:${password}`, 'utf8').toString('base64');

  const { data } = await api.post<Auth>(
    '/auth',
    {
      grant_type: 'client_credentials',
    },
    {
      headers: {
        Authorization: `Basic ${payload}`,
      },
    },
  );

  setItem(String(REACT_APP_AUTH), data.token);
  setItem(String(REACT_APP_USER), data.user);

  return data;
};
